import * as React from "react";

const CustomerDataContext = React.createContext();

const initialState = {
  customerName: "",
  customerPhoneNumber: "",
  uniqueId: "",
  loyaltyPoints: "",
  outstandingAmount: "",
  availableLoyaltyPoints: "",
  loyalty: {},
  loyaltyDiscount: 0,
};
const CustomerDataProvider = ({ children, ...props }) => {
  const [customerData, setCustomerData] = React.useState(initialState);

  const clearCustomerData = React.useCallback(() => {
    setCustomerData(initialState);
  }, []);

  const applyLoyaltyPoints = React.useCallback(
    (loyaltyData) => {
      let loyaltyDiscount = 0;
      const availableLoyaltyPoints =
        parseFloat(customerData.loyaltyPoints || 0) -
        parseFloat(loyaltyData.minLoyaltyPointsReq);
      if (loyaltyData?.rewardType?.name === "cash") {
        loyaltyDiscount = parseFloat(loyaltyData.rewardType.value);
      }
      setCustomerData((prev) => ({
        ...prev,
        availableLoyaltyPoints: availableLoyaltyPoints,
        loyalty: loyaltyData,
        loyaltyDiscount: loyaltyDiscount,
      }));
    },
    [customerData.loyaltyPoints]
  );

  const removeLoyaltyPoints = React.useCallback(
    (loyaltyData) => {
      const availableLoyaltyPoints = customerData.loyaltyPoints;
      setCustomerData((prev) => ({
        ...prev,
        availableLoyaltyPoints: availableLoyaltyPoints,
        loyalty: {},
        loyaltyDiscount: 0,
      }));
    },
    [customerData.loyaltyPoints]
  );

  const memorizedValue = React.useMemo(() => {
    return {
      customerData,
      setCustomerData,
      applyLoyaltyPoints,
      removeLoyaltyPoints,
      clearCustomerData,
    };
  }, [
    customerData,
    applyLoyaltyPoints,
    setCustomerData,
    removeLoyaltyPoints,
    clearCustomerData,
  ]);
  return (
    <CustomerDataContext.Provider value={memorizedValue} {...props}>
      {children}
    </CustomerDataContext.Provider>
  );
};

export default CustomerDataProvider;

export const useCustomerData = () => {
  const context = React.useContext(CustomerDataContext);
  if (context === undefined) {
    throw new Error(
      `useCustomerData must be used within a CustomerDataProvider`
    );
  }
  return context;
};
